import type {BridgeBarConfig} from "../config";

/**
 * URL of the signed-in user's Common Org memberships.
 *
 * Sends no `language`, though {@link BridgeBarConfig} carries one: the endpoint
 * stopped declaring the parameter, because a Common Org display name is not
 * localized.
 */
export function buildMembershipApiUrl(
  baseUrl: string,
  partitionQueryParameter: string,
  config?: BridgeBarConfig
): string {
  const params = new URLSearchParams();
  params.set("partition", partitionQueryParameter);

  if (config) {
    // Per-session cache-buster: differentiates the browser Cache-Control cache key
    // so a cached membership body is never reused across sessions (mirrors
    // buildBridgeBarApiUrl / user-details/mine). The backend ignores the param.
    params.set("sessionId", config.sessionId);
  }

  return `${baseUrl}/context/memberships/mine?${params.toString()}`;
}
